const CheckBoxSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <rect x="1.5" y="1.5" width="13" height="13" rx="3.5" stroke="#333333" />
      <path
        d="M6.73112 9.63057L11.1204 5.24131C11.224 5.13773 11.3448 5.08594 11.4829 5.08594C11.621 5.08594 11.7419 5.13773 11.8454 5.24131C11.949 5.34489 12.0008 5.46798 12.0008 5.61058C12.0008 5.75317 11.949 5.87609 11.8454 5.97933L7.09365 10.7441C6.99007 10.8477 6.86923 10.8994 6.73112 10.8994C6.59301 10.8994 6.47216 10.8477 6.36858 10.7441L4.14158 8.51707C4.038 8.41349 3.98828 8.29057 3.99243 8.14832C3.99657 8.00607 4.0506 7.88298 4.15453 7.77905C4.25846 7.67513 4.38155 7.62334 4.5238 7.62368C4.66605 7.62403 4.78897 7.67582 4.89255 7.77905L6.73112 9.63057Z"
        fill="#333333"
      />
    </svg>
  );
};

export default CheckBoxSvg;
